function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

export var Grid = /*#__PURE__*/function () {
  function Grid(grid, modifiers) {
    _classCallCheck(this, Grid);

    this.grid = grid;
    this.modifiers = modifiers;
    this.defaultContainerStyles = {
      display: 'grid',
      gridGap: '5px',
      gridTemplateAreas: this.getGridTemplateAreas(),
      gridTemplateColumns: this.getGridTemplateColumns(),
      gridTemplateRows: this.getGridTemplateRows()
    };
    Object.assign(this, {
      container: _objectSpread(_objectSpread({}, this.defaultContainerStyles), this.modifiers)
    });
    this.createGridAreas();
  }

  _createClass(Grid, [{
    key: "getGridTemplateAreas",
    value: function getGridTemplateAreas() {
      return this.grid.reduce(function (acc, value) {
        return "".concat(acc, " \"").concat(value, "\"");
      }, '');
    }
  }, {
    key: "getGridTemplateColumns",
    value: function getGridTemplateColumns() {
      var columns = Math.max.apply(Math, _toConsumableArray(this.grid.map(function (e) {
        return e.split(/\s+/).length;
      })));
      return _toConsumableArray(Array(columns).keys()).map(function () {
        return '1fr';
      }).join(' ');
    }
  }, {
    key: "getGridTemplateRows",
    value: function getGridTemplateRows() {
      return this.grid.map(function () {
        return '1fr';
      }).join(' ');
    }
  }, {
    key: "applyToStyles",
    value: function applyToStyles(styles) {
      var gridAreas = new Set(this.grid.join(' ').split(/\s+/));

      var gridElements = _toConsumableArray(gridAreas).reduce(function (acc, value) {
        acc[value] = {
          gridArea: value
        };
        return acc;
      }, {});

      return _objectSpread(_objectSpread({}, styles), {}, {
        container: _objectSpread(_objectSpread({}, this.defaultContainerStyles), this.modifiers)
      }, gridElements);
    }
  }, {
    key: "getGridContainerStyle",
    value: function getGridContainerStyle() {
      return _objectSpread(_objectSpread({}, this.defaultContainerStyles), this.modifiers);
    }
  }, {
    key: "createGridAreas",
    value: function createGridAreas() {
      var gridAreas = new Set(this.grid.join(' ').split(/\s+/));

      var gridElements = _toConsumableArray(gridAreas).reduce(function (acc, value) {
        acc[value] = {
          gridArea: value
        };
        return acc;
      }, {});

      Object.assign(this, gridElements);
    }
  }]);

  return Grid;
}();
//# sourceMappingURL=Grid.js.map